import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { defaultPageSize } from '@synergy/config';

import { PurchaseOrder } from '../../../common/models/purchase-order';
import {
    RECEIVE_PURCHASE_ORDERS,
    REQUEST_PURCHASE_ORDERS,
    RESET_PURCHASE_ORDERS,
} from '../actions/purchase-order-actions';

export interface PurchaseOrderDataReducerState {
    data: PaginatedResponse<PurchaseOrder>;
    requestingPurchaseOrderData: boolean;
}

const initialPurchaseOrderReducerState: PurchaseOrderDataReducerState = {
    data: { items: [], page: 0, limit: defaultPageSize, total: 0 },
    requestingPurchaseOrderData: false,
};

export const purchaseOrdersReducer = (
    state: PurchaseOrderDataReducerState = initialPurchaseOrderReducerState,
    action: AnyAction
): PurchaseOrderDataReducerState => {
    const { type, ...rest } = action;

    switch (type) {
        case REQUEST_PURCHASE_ORDERS: {
            return {
                ...state,
                requestingPurchaseOrderData: true,
            };
        }

        case RECEIVE_PURCHASE_ORDERS: {
            return {
                ...state,
                data: rest['purchaseOrders'],
                requestingPurchaseOrderData: false,
            };
        }

        case RESET_PURCHASE_ORDERS: {
            return {
                ...state,
                data: initialPurchaseOrderReducerState.data,
            };
        }

        default: {
            return state;
        }
    }
};
